/* global PRODUCTION */

// dependencies
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { push } from "yarrr";
import { GenerateProcess } from "redux-process";
import Cookies from "js-cookie";

// components
import Logo from "assets/img/logo";
import Button from "Components/Button";
import TextInput from "Components/Inputs/Text";

// actions
import { setupAuthenticatedEnvironment } from "Actions/authentication";

// styles
import css from "./MultiFactorLogin.styl";

export default function MultiFactorLoginPage() {
	const dispatch = useDispatch();
	const [mfaCode, setMfaCode] = useState("");

	/**
	 * REST POST to auth/mfa-login
	 * posts the mfa code and checks if it's correct
	 * @returns {Promise<void>}
	 */
	const handleAuthenticate = async () => {
		const request = await dispatch(
			GenerateProcess("MfaAuthenticate", {
				payload: {
					mfaCode,
				},
			})
		);

		if (request.response.isValid) {
			dispatch(setupAuthenticatedEnvironment());
			dispatch(push("/"));
		}
	};

	// Calls handleAuthenticate when user presses Enter
	const handleKeyDown = async (e) => {
		if (e.key === "Enter") {
			await handleAuthenticate();
		}
	};

	// Calls handleAuthenticate when user clicks Login button
	const handleLoginClick = async () => {
		await handleAuthenticate();
	};

	return (
		<div className={css.mfaLoginPage}>
			<div className={css.mfaLoginContainer}>
				<div className={css.logoContainer}>
					<h1>Logan</h1>
					<Logo width={150} height={150} />
				</div>

				<div className={css.formContainer}>
					<div className={css.inputContainer}>
						<div className="label">MFA Code</div>
						<input
							className={css.input}
							value={mfaCode}
							onChange={(e) => setMfaCode(e.target.value)}
							placeholder="Enter your 6 digit code."
							type="text"
							name="Enter your 6 digit code."
							onKeyDown={(e) => handleKeyDown(e)}
						/>
					</div>

					<div className={css.inputContainer}>
						<Button onClick={(e) => handleLoginClick(e)}>Login</Button>
					</div>
				</div>
			</div>
		</div>
	);
}
